import Link from 'next/link';

type SiteHeaderProps = {
  /** Target for “Get free report” (e.g. `/map` or `/map?postcode=SW1`). */
  mapReportHref?: string;
};

export function SiteHeader({ mapReportHref = '/map' }: SiteHeaderProps) {
  return (
    <header className="sticky top-0 z-40 border-b border-black/10 bg-[#faf8f4]/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Link href="/" className="flex items-center gap-2">
          <BrandLogo />
        </Link>
        <nav className="hidden items-center gap-1 text-sm text-[#3a3935] md:flex">
          <Link href="/#postcode-search" className="rounded-md px-3 py-1.5 transition hover:bg-[#f3f0ea]">
            Search
          </Link>
          <Link href="/map" className="rounded-md px-3 py-1.5 transition hover:bg-[#f3f0ea]">
            Map
          </Link>
          <Link href="/analytics" className="rounded-md px-3 py-1.5 transition hover:bg-[#f3f0ea]">
            Market Trends
          </Link>
          <Link href="/#recent-sales" className="rounded-md px-3 py-1.5 transition hover:bg-[#f3f0ea]">
            Sold Prices
          </Link>
        </nav>
        <div className="flex items-center gap-2">
          <Link
            href="/analytics"
            className="rounded-md border border-black/15 px-3 py-1.5 text-xs font-medium text-[#3a3935]"
          >
            Sign in
          </Link>
          <Link
            href={mapReportHref}
            className="rounded-md bg-[#1a4a3a] px-3 py-1.5 text-xs font-medium text-white transition hover:bg-[#2d7a5f]"
          >
            Get free report
          </Link>
        </div>
      </div>
    </header>
  );
}

export function BrandLogo() {
  return (
    <>
      <div className="flex h-8 w-8 items-center justify-center rounded-[10px] bg-[#1a4a3a]">
        <svg viewBox="0 0 16 16" fill="none" className="h-4 w-4" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 1L2 6v8h4v-4h4v4h4V6L8 1z" fill="white" opacity="0.9" />
        </svg>
      </div>
      <span className="font-serif text-[34px] leading-none font-semibold tracking-[-0.02em] text-[#0f0f0d]">
        <span className="align-middle text-[0.5em]">Postcode</span>
        <span className="align-middle text-[0.5em] text-[#2d7a5f]">Prices</span>
      </span>
    </>
  );
}
